module.exports = __webpack_public_path__ + "static/media/bphtb2.015056a8.png";